<template>
  <div>
    <v-select
      outlined
      attach
      :menu-props="{ bottom: true, offsetY: true }"
      :color="color"
      :items="budgets"
      :loading="loading"
      :value="value"
      @input="$emit('input', $event)"
      :label="label"
      item-value="budgetId"
      :item-text="
        (item) =>
          `${item.budgetDisplayName}: ${formatCurrency(item.budgetBalance, item.Award, true)}`
      "
      :no-data-text="loading ? 'Loading your budgets' : 'No budgets found'"
      :rules="[(v) => !!v || 'Budget is required']"
      @blur="onBlur"
      class="review-page-field"
      :hide-details="hideDetails"
    >
      <template v-slot:item="{ item }">
        <div class="d-flex align-center justify-space-between full-width">
          <span :title="item.budgetDisplayName" class="budget-name-container text-overflow-clip">
            {{ item.budgetDisplayName }}
          </span>
          <span class="text-right word-break">
            {{ formatCurrency(item.budgetBalance, item.Award, true) }}
          </span>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import formatCurrencyMixin from "@/mixins/formatCurrency";
export default {
  mixins: [formatCurrencyMixin],
  name: "BudgetSelector",
  props: {
    label: {
      type: String,
      default: "Budget",
    },
    color: {
      type: String,
      default: "brandPrimary",
    },
    budgets: {
      type: Array,
      required: true,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
      default: null,
    },
    hideDetails: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["blur"],
  methods: {
    onBlur() {
      this.$emit("blur");
    },
  },
};
</script>

<style scoped>
.budget-name-container {
  width: calc(100% - 120px);
}
</style>
